import { useState } from 'react';
import { listContacts } from 'services/Contact/contactServices';
import { sortByKey } from 'utils/utils';
import { totalCountReferredToContact } from 'services/generalServices';

export function useReferredToContact(isLead = false, contactType = '', isReferralEntity = false) {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const searchAsync = async (e) => {
    try {
      setLoading(true);

      // Get total count first
      const totalCountResponse = await totalCountReferredToContact('contact', true);
      const limit = totalCountResponse?.data || 20; // fallback to 20 if no data

      const response = await listContacts({
        contactType,
        keyWord: e?.query,
        pageLimit: limit,
        excludeFromLoading: true,
        in_lead: isLead,
        is_referral_entity: isReferralEntity,
      });

      // Sort contacts alphabetically by first_name
      const sortedContacts = response?.data?.contacts ? sortByKey(response.data.contacts, 'first_name') : [];
      setResults(sortedContacts);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  };

  return { contactList: results, searchAsync, loading, setResults };
}
